<template>
  <div class="staff">
      <!--        <el-card>-->
      <!--            <el-breadcrumb separator="/">-->
      <!--                <el-breadcrumb-item :to="{ name: 'workspace' }">首页</el-breadcrumb-item>-->
      <!--                <el-breadcrumb-item>商品管理</el-breadcrumb-item>-->
      <!--                <el-breadcrumb-item>商品管理</el-breadcrumb-item>-->
      <!--            </el-breadcrumb>-->
      <!--        </el-card>-->
      <main class="content">
          <!--搜索区-->
          <el-card>
              <el-container>
                  <el-aside width="220px" :style="{height: treeConfig.height + 'px', marginRight: '10px'}">
                      <div ref="treePosition"></div>
                      <el-tree size="mini"
                          :load="loadTree"
                          ref="tree"
                          lazy
                          node-key="id"
                          :props="props"
                          :current-node-key="searchForm.categoryId"
                          highlight-current="true"
                          :expand-on-click-node="false"
                          :default-expanded-keys="['root']"
                          accordion
                          @current-change="changeTreeNode">
                          <div class="custom-tree-node" slot-scope="{ node, data }">
                              <span style="flex-grow: 1; font-size: 12px;">
                                  <span slot="reference"><i v-if="node.data.fid == 'root'" :class="node.data.icon"></i>{{ node.data.name }}</span>
                              </span>
                          </div>
                      </el-tree>
                  </el-aside>
                  <el-main>
              <!--数据展示区-->
              <div ref="tablePosition"></div>
              <el-table
                  stripe
                  :data="tableData"
                  v-loading="loading"
                  style="width: 100%"
                  size="mini"
                  :row-class-name="rowClassName"
                  @selection-change="handleSelectionChange"
                  :height="tableConfig.height"
              >
                  <!-- <el-table-column type="selection" width="55" fixed/> -->
                  <el-table-column prop="label" label="标签" min-width="200"/>
                  <el-table-column label="操作" width="150" align="right" fixed="right">
                      <template slot="header" slot-scope="header">
                          <el-button type="primary" @click="handleCreate" size="mini" :disabled="searchForm.categoryLevel === 1">添加</el-button>
                      </template>
                      <template slot-scope="scope">
                          <el-button type="text" size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
                          <el-divider direction="vertical" ></el-divider>
                          <el-button type="text" size="mini" @click="doDelete(scope.row.id)">删除</el-button>
                      </template>
                  </el-table-column>
              </el-table>
          </el-main>
          </el-container>
          </el-card>
      </main>
      <el-dialog title="新建标签" :modal="true" :visible.sync="uploadDialogVisible" width="400px">
        <el-form ref="editForm" :model="editForm" :rules="rules" label-width="135px">
          <el-form-item label="ID" prop="id" hidden>
              <el-input v-model="editForm.id" placeholder="请输入ID" clearable></el-input>
          </el-form-item>
          <el-form-item label="标签" prop="label">
              <el-input v-model="editForm.label" placeholder="请输入标签" clearable></el-input>
          </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
          <el-button @click="uploadDialogVisible = false" size="small">取 消</el-button>
          <el-button type="primary" @click="doCreate" size="small">确 定</el-button>
      </div>
      </el-dialog>
  </div>
</template>
<script>
import { downloadByPost, convertRes2Blob } from '../../utils/download.js';
const HEIGHT_OFFSET = 118;
export default {
  data() {
      return {
          props: {
              id: "id",
              label: 'name',
              children: 'children',
              isLeaf: 'leaf'
          },
          tableConfig: {
              height: 0,
          },
          treeConfig: {
              height: 0,
          },
          searchForm: {
              categoryLevel: 1,
              categoryId: "root",
              sku: "",
              supplier: "",
              supplierSku: "",
              name: "",
              brand: "",
              status: "",
              lockPrice: false
          },
          editForm: {
            id: '',
            label: '',
          },
          rejectForm: {
              id: "",
              reason: "",
          },
          statusOptions: [
              {
                  value: "",
                  label: "全部",
              },
              {
                  value: "0",
                  label: "下架",
              },
              {
                  value: "1",
                  label: "上架",
              },
          ],
          loading: false,
          total: 0,
          pageSize: 10,
          currentPage: 1,
          tableData: [],
          uploadCheckResult: "",
          rejectDialogVisible: false,
          uploadDialogVisible: false,
          selectData: [],
          searchFormStash: {},
          drawer: false,
          propertyId: '',
          propertyName: '',
          valueData: [],
          valueLoading: false,
          valueDialogVisible: false,
          editValueForm: {
            id: '',
            value: '',
            sort: 0,
          },
          rules: {
            label: [
                  { required: true, message: '请输入标签', trigger: 'blur' }
              ],
              filter: [
                  { required: true, message: '请选择状态', trigger: 'blur' }
              ],
              allowNonOption: [
                  { required: true, message: '请选择状态', trigger: 'blur' }
              ],
              isBrand: [
                  { required: true, message: '请选择状态', trigger: 'blur' }
              ],
              value: [
                  { required: true, message: '请输入值', trigger: 'blur' }
              ],
              sort: [
                  { required: true, message: '请输入排序', trigger: 'blur' }
              ],
          },
      }
  },
  // computed: {
  //     tableHeight() {
  //         return this.$store.state.clientHeight - 320;
  //     }
  // },
  methods: {
      onSearch() {

          this.loading = true;
          let _this = this
          this.$axios.get(`/admin/product/category/label/${this.searchForm.categoryId}`)
          .then(function (response) {
              let resp = response.data;
              if (resp.header.status == 0) {
                  _this.loading = false;
                  _this.tableData = resp.data;
              }
          }).catch(function () {
          });
      },
      handleCreate() {
        this.editForm = {
          id: '',
          name: '',
          filter: true,
          allowNonOption: false,
          isBrand: false,
          sort: 0,
        }
        this.uploadDialogVisible = true;
      },
      doCreate() {
        const that = this;
        that.$refs.editForm.validate(valid => {
          if (valid) {
            that.$axios.post("/admin/product/category/label/save", {...that.editForm, categoryId: that.searchForm.categoryId})
            .then(() => {
              that.uploadDialogVisible = false;
              that.onSearch();
            });
          }
        });
      },
      doDelete(id) {
        const that = this;
        that.$axios.post(`/admin/product/category/label/delete/${id}`)
        .then(() => {
          that.onSearch();
        });
      },
      handleEdit(index, row) {
        this.editForm = {...row};
        this.uploadDialogVisible = true;
      },
      handleShowValues(row) {
        // const that = this;
        this.drawer = true;
        this.propertyId = row.id;
        this.propertyName = row.name;
        this.onSearchValue();
      },

      handleCreateValue() {
        this.editValueForm = {
          id: '',
          value: '',
          sort: 0,
        }
        this.valueDialogVisible = true;
      },
      uploadSuccess(response) {
          const {header: {status, msg}} = response;
          this.$refs.upload.clearFiles();
          if(status === 0) {
              this.$notify({
                  title: '成功',
                  message: '数据保存成功',
                  type: 'success'
              });
              this.uploadDialogVisible = false;
              this.onSearch();
          } else {
              this.uploadCheckResult = msg;
          }
      },
      formatterMoney(row, col, value) {
          if(value) {
              return this.MoneyFormat(value, "", 2);
          } else {
              return "-";
          }
      },
      handleSelectionChange(val) {
          this.selectData = val;
      },
      more(command) {
          const that = this;
          switch(command) {
              case 'add':
                  this.handleCreate();
                  break;
              case 'publish':
                  this.loading = true;
                  this.$confirm('确定上架已选择商品吗？', '提示', {
                      distinguishCancelAndClose: true,
                      confirmButtonText: '确认',
                      cancelButtonText: '取消'
                  }).then(() => {
                      that.$axios.post("/admin/product/publish",
                          that.selectData.map(it => it['id']),
                      ).then(function (response) {
                          let resp = response.data;
                          if (resp.header.status !== 0) {
                              that.$notify.error({
                                  title: '错误',
                                  message: resp.header.msg
                              });
                          }
                          that.onSearch();
                      }).finally(() => {
                      });
                  });
                  break;
              case 'off':
                  this.loading = true;
                  this.$confirm('确定下架已选择商品吗？', '提示', {
                      distinguishCancelAndClose: true,
                      confirmButtonText: '确认',
                      cancelButtonText: '取消'
                  }).then(() => {
                      that.$axios.post("/admin/product/off",
                          that.selectData.map(it => it['id']),
                      ).then(function (response) {
                          let resp = response.data;
                          if (resp.header.status == 0) {
                              that.onSearch();
                          } else {
                              that.$notify.error({
                                  title: '错误',
                                  message: resp.header.msg
                              });
                          }
                      }).finally(() => {
                      });
                  });
                  break;
              case 'exportAll':
              case 'exportSelected':
                  this.export(command);
                  break;
          }

      },
      export(command) {
          let data = {};
          switch(command) {
              case 'exportAll': {
                  if(this.total > 5000) {
                      this.$notify.info({
                          title: '提示',
                          message: '一次最多导出5000条数据',
                      });
                      return;
                  }
                  data = {...this.searchFormStash};
                  break;
              }
              case 'exportSelected': {
                  if (this.selectData.length == 0) {
                      this.$message({
                          type: 'error',
                          message: '请选择要导出的订单',
                          duration: 2000
                      });
                      return;
                  }
                  if(this.selectData.length > 5000) {
                      this.$notify.info({
                          title: '提示',
                          message: '一次最多导出5000条数据',
                      });
                      return;
                  }
                  data = {ids: this.selectData.map(it => it.id)};
                  break;
              }
          }
          this.loading = true
          downloadByPost({
              axios: this.$axios,
              url: command === 'exportAll' ? "/admin/product/exportAll" : "/admin/product/export",
              data,
              success: response => {
                  convertRes2Blob(response);
              },
              complete: () => {
                  this.loading = false;
              }
          });
      },
      rowClassName({row, rowIndex}) {
          if(row.lockPrice && row.calcPrice >= row.price){
              return 'warnprice'
          }
          else {
              return ''
          }
      },
      setTableHeight() {
          const tablePosition = this.$refs['tablePosition'];
          const {top} = tablePosition.getBoundingClientRect();
          this.tableConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
      },
      setTreeHeight() {
          const treePosition = this.$refs['treePosition'];
          const {top} = treePosition.getBoundingClientRect();
          this.treeConfig.height = window.innerHeight - top - HEIGHT_OFFSET;
      },
      loadTree(node, resolve) {
          if(node.level === 0) {
              resolve([{id: "root", name: "全部产品分类", type: 0, description: "", uri: "-", status: 1, level: -1}]);
          } else {
              this.loading = true;
              let _this = this;
              this.$axios.post("/admin/product/category/list", {
                  fid: node.data.id,
              }).then(function(response) {
                  let resp = response.data;
                  if(resp.header.status == 0) {
                      resolve(resp.data.map(it => ({...it, leaf: (it.children || []).length === 0})));
                  } else {
                      _this.$notify.error({
                          title: '错误',
                          message: resp.header.msg
                      });
                  }
                  _this.loading = false;
              }).catch(function(error) {
                  _this.loading = false;
              });
          }
      },
      changeTreeNode(data, node) {
            this.searchForm.categoryId = node.data.id;
            this.searchForm.categoryLevel = node.level;
            this.currentPage=1;
            if(node.level === 1) {
                this.tableData = [];
            } else {
                this.onSearch();
            }
      },
  },
  created() {
      this.onSearch();
      window.addEventListener("resize", this.setTableHeight);
      window.addEventListener("resize", this.setTreeHeight);
  },
  activated() {
      setTimeout(() => {
          this.setTableHeight();
          this.setTreeHeight();
      }, 500);
  },
  mounted() {
      setTimeout(() => {
          this.setTableHeight();
          this.setTreeHeight();
      }, 500);
  },
  destroyed () {
      window.removeEventListener("resize", this.setTableHeight);
      window.removeEventListener("resize", this.setTreeHeight);
  },
}
</script>
<style>
  .el-table .warnprice {
      background: rgb(255 232 198);
  }
</style>